import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DrawerMenu } from '@player/+survey/drawer/drawer-menu.component';
import { LanguageSelect } from '@player/+survey/drawer/language-select/language-select.component';
import { Funnel } from '@player/+survey/funnel/funnel.component';
import { OutcomeCard } from '@player/+survey/outcome/outcome-card.component';
import { OutcomesScrollbar } from '@player/+survey/outcomes/outcomes-scrollbar.component';
import { AIInterviewer } from '@player/+survey/question/ai-interviewer/ai-interviewer.component';
import { FileUpload } from '@player/+survey/question/file-upload/file-upload.component';
import { InputCheckbox } from '@player/+survey/question/input-checkbox/input-checkbox.component';
import { InputChoicePicture } from '@player/+survey/question/input-choice-picture/input-choice-picture.component';
import { InputChoice } from '@player/+survey/question/input-choice/input-choice.component';
import { InputDropdown } from '@player/+survey/question/input-dropdown/input-dropdown.component';
import { InputInfo } from '@player/+survey/question/input-info/input-info.component';
import { InputOther } from '@player/+survey/question/input-other/input-other.component';
import { InputPhone } from '@player/+survey/question/input-phone/input-phone.component';
import { InputSimple } from '@player/+survey/question/input-simple/input-simple.component';
import { Slider1D } from '@player/+survey/question/slider-1d/slider-1d.component';
import { Slider1R } from '@player/+survey/question/slider-1r/slider-1r.component';
import { Slider2D } from '@player/+survey/question/slider-2d/slider-2d.component';
import { SliderENps } from '@player/+survey/question/slider-nps/slider-e-nps.component';
import { SliderNps } from '@player/+survey/question/slider-nps/slider-nps.component';
import { WhyFinder } from '@player/+survey/question/why-finder/why-finder.component';
import { QuestionsScrollbar } from '@player/+survey/questions/questions-scrollbar.component';
import { WelcomeCard } from '@player/+survey/welcome/welcome-card.component';
import { BrandMenu } from '@player/shared/components/brand-menu/brand-menu.component';
import { BrandName } from '@player/shared/components/brand-name/brand-name.component';
import { BrandWordmark } from '@player/shared/components/brand-wordmark/brand-wordmark.component';
import { CardScroll } from '@player/shared/components/card-scroll/card-scroll.component';
import { FunnelOne } from '@player/shared/components/funnel-one/funnel-one.component';
import { FunnelTwo } from '@player/shared/components/funnel-two/funnel-two.component';
import { OptionsDropdown } from '@player/shared/components/options-dropdown/options-dropdown.component';
import { PictureImage } from '@player/shared/components/picture-image/picture-image.component';
import { PromoText } from '@player/shared/components/promo-text/promo-text.component';
import { ShareButtons } from '@player/shared/components/share-buttons/share-buttons.component';
import { Sheet } from '@player/shared/components/sheet/sheet.component';
import { SliderImages } from '@player/shared/components/slider-images/slider-images.component';
import { SliderLabel } from '@player/shared/components/slider-label/slider-label.component';
import { SliderThumb } from '@player/shared/components/slider-thumb/slider-thumb.component';
import { LabelOverflow } from '@player/shared/directives/label-overflow.directive';
import { PictureZoom } from '@player/shared/directives/picture-zoom.directive';
import { SurveyScroller } from '@player/shared/directives/survey-scroller.directive';
import { SharedModuleForPlayer } from '@player/shared/modules/shared.module';
import { SliderAnswer } from '@player/shared/pipes/slider-answer.pipe';
import { BasicModule } from '@shared/modules/basic.module';
import { SafeHtml } from '@shared/pipes/safe-html.pipe';
import { NG_SCROLLBAR_OPTIONS, NgScrollbarModule } from 'ngx-scrollbar';

@NgModule({
  imports: [
    CommonModule,
    BasicModule,
    SharedModuleForPlayer,
    NgScrollbarModule,
    PortalModule,
    OverlayModule,
    BrandWordmark,
    BrandMenu,
    BrandName,
    InputInfo,
    SafeHtml,
    SliderLabel,
    SliderThumb,
    SliderImages,
    SliderAnswer,
    // QuestionCard,
    Slider1D,
    Slider1R,
    Slider2D,
    SliderNps,
    SliderENps,
    AIInterviewer,
    InputSimple,
    InputPhone,
    InputOther,
    InputChoice,
    InputCheckbox,
    InputDropdown,
    InputChoicePicture,
    WhyFinder,
    FileUpload,
    OptionsDropdown,
    PictureImage,
    PictureZoom,
    CardScroll,
    ShareButtons,
    FunnelTwo,
    FunnelOne,
    PromoText,
    LanguageSelect,
    DrawerMenu,
    WelcomeCard,
    OutcomeCard,
    Funnel,
    Sheet,
    LabelOverflow,
    OutcomesScrollbar,
    QuestionsScrollbar,
    SurveyScroller,
    // SurveyView,
  ],
  providers: [
    {
      provide: NG_SCROLLBAR_OPTIONS,
      useValue: {
        autoHeightDisabled: true,
        track: 'vertical',
        appearance: 'standard',
        visibility: 'hover',
        trackClickScrollDuration: 0,
      },
    },
  ],
})
export class SurveyModule {}
